const AccountType = {
  INDIVIDUAL: 'INDIVIDUAL',
  MINOR: 'MINOR',
  SMSF: 'SMSF',
  TRUST: 'TRUST',
  CORPORATION: 'CORPORATION',
  ADVISOR: 'ADVISOR',
  INTERNAL: 'INTERNAL',
  JOINT: 'JOINT',
  DECEASED: 'DECEASED',
  PARTNERSHIP: 'PARTNERSHIP',
  GOVERNMENT: 'GOVERNMENT',
  OTHERNONINDIVIDUAL: 'OTHERNONINDIVIDUAL',
};

export default AccountType;
